/**
 * Converting a draft when the composer switches channel: an email body is HTML (rich editor), an SMS is
 * plain text. Carrying one over unchanged showed "<p>Hi {{first_name}},</p>…" in the SMS box.
 */

/** HTML → plain text, keeping paragraphs and line breaks as newlines. */
export function htmlToPlainText(html: string): string {
  if (!html.trim()) return ''
  const doc = new DOMParser().parseFromString(
    html.replace(/<br\s*\/?>/gi, '\n').replace(/<\/(p|div|li|h[1-6])>/gi, '\n'),
    'text/html',
  )
  return (doc.body.textContent ?? '')
    .replace(/\u00a0/g, ' ')
    .replace(/\n{3,}/g, '\n\n')
    .trim()
}

/** A stored body for the rich editor: HTML as is, an older plain-text one as paragraphs (keeping its breaks). */
export function bodyForRichEditor(body: string): string {
  return /<\/?(p|br|div|ul|ol|li|b|strong|i|em|a|span|h[1-3])\b/i.test(body) ? body : plainTextToHtml(body)
}

/** Plain text → simple HTML paragraphs, escaping markup; tokens like {{first_name}} pass through. */
export function plainTextToHtml(text: string): string {
  if (!text.trim()) return ''
  const esc = (s: string) => s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
  return text
    .split(/\n{2,}/)
    .map((para) => `<p>${esc(para).replace(/\n/g, '<br>')}</p>`)
    .join('')
}
